import { PlayCircle } from '@backyard-ui/icons';
import { mediasCarouselTracker as tracker } from '@leroy-merlin-br/backpack-analytics';

import { algolia } from '@/infra/tracking/algolia';
import { Image } from '@/presenters/components/common/Image';
import { useProductStore } from '@/presenters/store/catalog/product';

import { type Media, Sketch3D, Video } from '../utils/build-visual-medias';

import { styles } from './NavigatorItem.styles';

interface NavigatorItemProps {
  media: Media;
  onClick: () => void;
  isActive: boolean;
}

function NavigatorItem(props: Readonly<NavigatorItemProps>) {
  const { media, onClick, isActive, ...rest } = props;

  const { alt, thumbSrc } = media;

  const classNames = styles();

  const { _id: productId } = useProductStore((state) => state.product);

  const isVideo = media instanceof Video;
  const isSketch3D = media instanceof Sketch3D;

  const handleClick = () => {
    algolia.sendPdpClickEvent();

    if (isVideo) {
      tracker.pushClickVideo({ productId: productId });
    }

    if (isSketch3D) {
      tracker.pushClick3d({ productId: productId });
    }

    onClick();
  };

  return (
    <button
      className={classNames.base({
        isActive,
      })}
      onClick={handleClick}
      data-is-active={isActive}
      {...rest}
    >
      {(isVideo || isSketch3D) && (
        <PlayCircle
          className={classNames.playButton()}
          data-testid="play-circle"
        />
      )}
      <Image src={thumbSrc} alt={alt} sizes="140px" fill />
    </button>
  );
}

export default NavigatorItem;
